import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="relative py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://cdn.prod.website-files.com/68b07a689aa678cd7b4261c6/68c47978c3083941a17ca9bc_p6.avif"
          alt="Security Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-dark-900/90 to-dark-900/70"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 font-display">
            Ready to Secure Your Property?
          </h2>
          <p className="text-xl text-dark-100 mb-8">
            Get a free consultation and customized security quote today. Our team is ready to provide the support and protection you need, wherever you are nationwide.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/contact"
              className="px-8 py-4 bg-primary-500 text-dark-900 rounded-lg text-base font-semibold hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap inline-flex items-center justify-center cursor-pointer"
            >
              Get A Free Quote
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <a
              href="tel:1-800-662-7372"
              className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 rounded-lg text-base font-semibold hover:bg-white/20 transition-all whitespace-nowrap inline-flex items-center justify-center cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              Call 1-800-662-7372
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;